// extracted by mini-css-extract-plugin
module.exports = {"mask":"DataPreloader_mask__3yZ55","loaded":"DataPreloader_loaded__WanxX"};